/**
 * Walker-free navigation with native buttons for mobile and nested submenus.
 */
export function initNavigation(scope = document) {
  const menu = scope.querySelector('#primary-menu');
  const toggle = scope.querySelector('.navbar-toggler');
  const submenuIcon = scope.querySelector('.js-submenu-icon');
  if (!menu || !toggle || menu.dataset.initialized) return;
  menu.dataset.initialized = 'true';

  const desktop = window.matchMedia('(min-width: 992px)');
  const setMenu = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.classList.toggle('collapsed', !open);
    menu.hidden = !open;
  };
  const closeSubmenus = () => {
    menu.querySelectorAll('.submenu-toggle').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      button.nextElementSibling.hidden = true;
    });
  };

  menu.querySelectorAll('.menu-item-has-children').forEach((item, index) => {
    const submenu = Array.from(item.children).find((el) =>
      el.classList.contains('sub-menu')
    );
    const link = Array.from(item.children).find((el) => el.tagName === 'A');
    if (!submenu || !link) return;

    submenu.id = `primary-submenu-${index}`;
    submenu.hidden = true;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'submenu-toggle';
    // The accessible name is the adjacent, localized WordPress menu item label.
    button.setAttribute('aria-label', link.textContent.trim());
    button.setAttribute('aria-controls', submenu.id);
    button.setAttribute('aria-expanded', 'false');
    if (submenuIcon) {
      button.append(submenuIcon.content.cloneNode(true));
    }
    item.insertBefore(button, submenu);
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      submenu.hidden = !open;
    });
  });

  toggle.addEventListener('click', () => {
    setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    if (menu.hidden) closeSubmenus();
  });

  menu.addEventListener('click', (event) => {
    if (event.target.closest('a') && !desktop.matches) {
      setMenu(false);
      closeSubmenus();
    }
  });

  toggle.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !desktop.matches) {
      setMenu(false);
      closeSubmenus();
    }
  });

  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const submenu = event.target.closest('.sub-menu');
    if (submenu) {
      submenu.hidden = true;
      submenu.previousElementSibling.setAttribute('aria-expanded', 'false');
      submenu.previousElementSibling.focus();
    } else if (!desktop.matches) {
      setMenu(false);
      closeSubmenus();
      toggle.focus();
    } else {
      closeSubmenus();
    }
    event.stopPropagation();
  });

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target) && !toggle.contains(event.target)) {
      closeSubmenus();
      if (!desktop.matches) setMenu(false);
    }
  });

  const syncViewport = () => {
    closeSubmenus();
    setMenu(desktop.matches);
  };
  desktop.addEventListener('change', syncViewport);
  syncViewport();
}
